import { useTranslation } from '@thoughtspot/i18n';
import { useAdminContext, useNavigationContext } from "./context";
export const BasePageContext = () => {
    const { t } = useTranslation();
    const { navService } = useNavigationContext();
    const { rootPath, metricsService, sessionService, metadataService, metadataList, systemConfigService, teamComponents, styleComponents, quickLinkContainer, connectorsComponents, homeModuleCustomizationContainer, } = useAdminContext();
    return {
        t,
        rootPath,
        navService,
        metricsService,
        sessionService,
        metadataService,
        metadataList,
        systemConfigService,
        teamComponents,
        styleComponents,
        quickLinkContainer,
        connectorsComponents,
        homeModuleCustomizationContainer,
    };
};
//# sourceMappingURL=basepage-context.js.map